$('.multi-slider').slick({
  dots: false,  
  infinite: true,
  speed: 600,
  autoplay: true,
  autoplaySpeed: 1500,
  slidesToShow: 9,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1445,
      settings: {
        slidesToShow: 7,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    { 
      breakpoint: 1025,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1
      }
    },
    { 
      breakpoint: 991,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    { 
      breakpoint: 767,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },  
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll:1 
      }
    }
  ]
});
// COUNTER DATE
var finalDate = $('#fetched_date').text();
$('#clock').countdown(finalDate)
.on('update.countdown', function(event) {
  var format = '<span>%H</span>:<span>%M</span>:<span>%S</span>';
  if(event.offset.totalDays > 0) {
    //  format = '%-d day%!d ' + format;
  }
  if(event.offset.weeks > 0) {
    //  format = '%-w week%!w ' + format;
  }
  $(this).html(event.strftime(format));
  $('.timer .left-text').show();
})
.on('finish.countdown', function(event) {
  $(this).html('This offer has expired!')
  .parent().addClass('disabled');
  $('#shopify-section-Countdown-Timer').hide();
   $('.timer.disabled .left-text').hide();
  
});


// menu js 
jQuery(document).ready(function($){
  $('#SiteNav li').hover(
    function(){ $(this).addClass('site-nav--active-dropdown') },
    function(){ $(this).removeClass('site-nav--active-dropdown') }
  )
});


// login pop up
if ($(window).width() < 1025) {
  $(".login_popup").hover(function(){
    if ($('.account-popup').css('opacity') == 0) {
      $('.account-popup').css({"opacity":"1","visibility":"visible"});
      $('.dropdown-content').css({"opacity":"0","visibility":"hidden"});
    }
    else {
      $('.account-popup').css({"opacity":"0","visibility":"hidden"});
    }   
  });
  $(".more_popup.fa").hover(function(){
    setTimeout(function () {
      if ($('.more-section-popup').css('opacity') == 0) {
        $('.more-section-popup').css({"opacity":"1","visibility":"visible"});
        $('.dropdown-content').css({"opacity":"0","visibility":"hidden"});
      }
      else {
        $('.more-section-popup').css({"opacity":"0","visibility":"hidden"});
      }
    }, 100);
  });

}
//
jQuery(".minus_btn").click(function () {
  var inputEl = jQuery(this).next();
  var qty = inputEl.val();
  if (jQuery(this).parent().hasClass("minus_btn"))
    qty++;
  else
    qty--;
  if (qty < 1)
    qty = 1;
  inputEl.val(qty);
})


jQuery(".plus_btn").click(function () {
  var inputEl = jQuery(this).prev();
  var qty = inputEl.val();
  if (jQuery(this).hasClass("plus_btn"))
    qty++;
  else
    qty--;
  if (qty < 1)
    qty = 1;
  inputEl.val(qty);
})
/*****Video Gallery*****/
$( document ).ready(function() {
  $(".product-video").click(function(){
    $('.custom-modal-container#video-popup').addClass('six');
    $(".custom-modal-container#video-popup").fadeIn();
  });
  $(".custom-overlay").on("click", function(){
    $(this).addClass('out');
    $('.custom-modal-container#video-popup').removeClass('six');
    $(".custom-modal-container#video-popup").fadeOut();
  });

  $(".close-modal").on("click", function(){
    $('.custom-modal-container#video-popup').removeClass('six');
    $(".custom-modal-container#video-popup").fadeOut();
    $(this).addClass('out');
  });

  var iframesrc = $('.description-tab iframe').attr('src');
  var target = document.getElementById("video-gallery");
  var newFrame = document.createElement("iframe");

  newFrame.setAttribute("src", iframesrc);

  target.appendChild(newFrame);
  if($('#video-gallery iframe').attr('src') != 'undefined'){
    $('.product-video').show();
  }
  else{
    $('.product-video').hide();
  }
  //   $( window ).load(function(){
  //     $('.swatch .swatch-element:nth-child(2) input:radio').prop('checked', true);
  //     $('.swatch .color:nth-child(2) input:radio').prop("checked", true);
  //   });
  if($('.swatch').length > 0){
    if($('.swatch .swatch-element input:radio').prop('checked', false) || $('.swatch .color input:radio').prop("checked", false)) {
      console.log('OK');
      $('.product-form__cart-submit').prop('disabled', true);
    }
  }
  else{
    $('.product-form__cart-submit').prop('disabled', false);
  }
});
// Loder Script
$(window).load(function(){
 $('.loader_block47').fadeOut();
});
// Loder Script End